import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly storageKey = 'inbordo.locale';
  private readonly supportedLocales = new Set(['en', 'tr']);

  constructor(private readonly translate: TranslateService) {}

  init(): void {
    const saved = localStorage.getItem(this.storageKey);
    const locale = this.normalizeLocale(saved) ?? this.normalizeLocale(environment.defaultLocale) ?? 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(locale).subscribe({
      next: () => localStorage.setItem(this.storageKey, locale),
      error: () => {
        this.translate.use('en').subscribe();
        localStorage.setItem(this.storageKey, 'en');
      }
    });
  }

  get currentLocale(): string {
    return this.normalizeLocale(this.translate.currentLang) ?? 'en';
  }

  setLocale(locale: string): void {
    const next = this.normalizeLocale(locale) ?? 'en';
    const previous = this.currentLocale;
    if (next === previous) {
      return;
    }

    this.translate.use(next).subscribe({
      next: () => localStorage.setItem(this.storageKey, next),
      error: () => this.translate.use(previous).subscribe()
    });
  }

  toggleLocale(): void {
    const next = this.currentLocale === 'en' ? 'tr' : 'en';
    this.setLocale(next);
  }

  private normalizeLocale(locale: string | null | undefined): string | null {
    const normalized = (locale ?? '').trim().toLowerCase();
    return this.supportedLocales.has(normalized) ? normalized : null;
  }
}
